import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import Layout from '../components/Layout';

/**
 * Strona „Przejmij wpis” – dla kominiarzy, których dane są w bazie z importu.
 * Wpisują email, dostają link do ustawienia hasła.
 */
const RequestClaimChimney = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Podaj adres email.');
      return;
    }
    setLoading(true);
    try {
      await authService.requestClaimChimney(email.trim());
      setSent(true);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        err.response?.data?.email?.[0] ||
        'Nie udało się wysłać linku. Sprawdź adres lub spróbuj później.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-bold text-ik-black mb-2">Przejmij swój wpis</h2>
            <p className="text-gray-600 text-sm mb-6">
              Jeśli Twoje dane są już w naszej bazie (np. z importu), podaj email powiązany z wpisem. Wyślemy na niego link do ustawienia hasła – tylko w ten sposób możesz przejąć ten wpis.
            </p>
            {sent ? (
              <div className="text-green-700 bg-green-50 border border-green-200 rounded-lg p-4">
                <p className="font-medium">Link został wysłany</p>
                <p className="text-sm mt-1">Sprawdź skrzynkę <strong>{email}</strong> (oraz folder „Spam”). Link jest ważny 7 dni.</p>
                <button
                  type="button"
                  onClick={() => { setSent(false); setEmail(''); }}
                  className="mt-3 text-sm text-ik-orange hover:underline"
                >
                  Wysłaj na inny adres
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                {error && (
                  <div className="bg-red-50 border border-red-400 text-red-700 px-4 py-3 rounded text-sm">
                    {error}
                  </div>
                )}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Adres email *
                  </label>
                  <input
                    id="email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="appearance-none relative block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-ik-orange focus:border-ik-orange sm:text-sm"
                    placeholder="jan@example.com"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2 px-4 bg-ik-orange text-white rounded-md hover:bg-orange-600 transition font-medium disabled:opacity-50"
                >
                  {loading ? 'Wysyłanie…' : 'Wyślij link do przejęcia wpisu'}
                </button>
              </form>
            )}
            <p className="mt-6 text-center text-sm text-gray-500">
              <Link to="/register-chimney" className="text-ik-orange hover:underline">Zarejestruj nowy wpis</Link>
              {' · '}
              <Link to="/login" className="text-ik-orange hover:underline">Logowanie</Link>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RequestClaimChimney;
